varying vec3 vNormal;
varying vec3 vViewPosition;
varying vec3 vModelPos;

void main() {
    vec4 mvPosition   = modelViewMatrix * vec4(position, 1.0);
    vNormal           = normalize(normalMatrix * normal);
    vViewPosition     = -mvPosition.xyz;
    vModelPos         = position;              
    gl_Position       = projectionMatrix * mvPosition;
}
